<template>
    <form-row title="Email Address">
        <input-text
            class="w-full"
            name="email"
            :value="broker.email"
            placeholder="Email"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        broker: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
